import axios from "axios";
import { environment } from "../../../environments/environment";
import { createPart } from "./PartsConfigurationService";

export function hierarchyUpdate(parts) {
  return Promise.all(parts.map(p => createPart(p))).then(responses => {
    return responses.map(r => r.data);
  })
}

export function positionsUpdate(positions){
  return axios.post(`${environment.savePositions}`, positions);
}

export function nlaUpdate(positions, parts=[], prevPositions){
  if (parts.length > 0) {
    let prevReq = (prevPositions?.filter(p => typeof(p.id) === 'number').length > 0) ? prevPositions.filter(p => typeof(p.id) === 'number').map(p => axios.delete(`${environment.deletePositions}?id=${p.id}`)):[];
    return Promise.all([axios.post(`${environment.savePositions}`, positions), ...parts.map(p => createPart(p)), ...prevReq]).then(responses => {
      let savedPositions = responses[0].data.load;
      if (responses.every(responseItem => (responseItem.data.responseCode >= 200) && (responseItem.data.responseCode <= 299))) {
        return ({...responses[responses.length - 1], data:{responseCode: 200, load: responses.map(r => r.data.load), message: "Request processed successfully", savedPositions}})
      } else {
        return ({...responses[responses.length -1], data:{...responses[responses.length  -1], allReq: responses}});
      }
    });
  } else {
    let prevReq = (prevPositions?.filter(p => typeof(p.id) === 'number').length > 0) ? prevPositions.filter(p => typeof(p.id) === 'number').map(p => axios.delete(`${environment.deletePositions}?id=${p.id}`)):[];
    return Promise.all([axios.post(`${environment.savePositions}`, positions), ...prevReq]).then(responses => {
      let savedPositions = responses[0].data.load;
      if (responses.every(responseItem => (responseItem.data.responseCode >= 200) && (responseItem.data.responseCode <= 299))) {
        return ({...responses[responses.length - 1], data:{responseCode: 200, load: responses.map(r => r.data.load), message: "Request processed successfully", savedPositions}})
      } else {
        return ({...responses[responses.length -1], data:{...responses[responses.length  -1], allReq: responses}});
      }
    });
  }
}

export function getNla(part, includePart=false, localNodeId = null) {
    return axios.post(`${environment.getDropdownData}`,
        {
            "id": 67,
            "search": "",
            "dependencies": [],
            "page": 0,
            "pageSize": 200,
            "parentComponentId": null,
            "filters": [],
            "parameters": [
                {
                    "columnName": "partId",
                    "value": part.id
                }
            ]
        }
    ).then(response => {
        if (response.data.responseCode === 200) {
            let parts = response.data.load;
            return Promise.all([...(includePart ? [part] : []),...parts].map(p => axios.get(`${environment.getPartConfigurationInfo}?partId=${p.id}`))).then(responses => {
                if (responses.every(responseItem => responseItem.data.responseCode === 200)) {
                    let parts = responses.map(r => ({part:r.data.load, nodeId: (localNodeId && (part.id === r.data.load.id)) ? localNodeId : crypto.randomUUID()})).map((n, _, a) => ({...n, parentNode:a.find(qN => qN.part.id === n.part.parentPartId)?.nodeId ?? n.part.parentPartId }));
                    return ({...response, data:{responseCode: 200, load: sortFlattenedTree(parts, "nodeId", "parentNode").map(i => ({...i, level: i.parentIds.length - 1})), message: "Request processed successfully"}})
                } else {
                    return ({...response, data:{responsdeCode: 500, load: [], message: "Something went wrong when retrieving NLAs" }});
                }
            }
            )
        } else {
            return { ...response };
        }
    })
}

function sortFlattenedTree(treeArray, idKey, parentIdKey) {
    const itemMap = new Map();
    const rootItems = [];
  
    // Populate the map and identify root-level items
    treeArray.forEach(item => {
      itemMap.set(item[idKey], { ...item, children: [], parentIds: [] }); // Add default parentIds
      if (!item[parentIdKey] || !itemMap.has(item[parentIdKey])) {
        rootItems.push(itemMap.get(item[idKey])); // Root-level items
      }
    });
  
    // Assign children to their respective parents
    treeArray.forEach(item => {
      if (item[parentIdKey] && itemMap.has(item[parentIdKey])) {
        const parent = itemMap.get(item[parentIdKey]);
        const child = itemMap.get(item[idKey]);
        // child.level = parent.level + 1; // Assign level based on parent's level
        child.parentIds = [...parent.parentIds, parent[idKey]]; // Build list of parent IDs
        parent.children.push(child);
      }
    });
  
    // Helper function to flatten the tree recursively
    function flattenTreeWithLevelsAndParentIds(items) {
      let result = [];
      items.forEach(item => {
        result.push(item);
        result = result.concat(flattenTreeWithLevelsAndParentIds(item.children));
        delete item.children; // Remove 'children' property in final result
      });
      return result;
    }
  
    // Sort, assign levels, include parent IDs, and return the final flattened tree
    return flattenTreeWithLevelsAndParentIds(rootItems);
  }
  